"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storable_realtime_subscriptions_1 = __importDefault(require("../../Data/storable-realtime-subscriptions"));
var data_store_1 = __importDefault(require("../../data-store"));
var storable_data_service_1 = __importDefault(require("../../storable-data-service"));
var Vehicle_consts_1 = require("../Vehicle.consts");
var vehicles_service_1 = __importDefault(require("./vehicles-service"));
var VehiclesApi = /** @class */ (function () {
    function VehiclesApi(session) {
        var groupFilters = [
            { groupType: Vehicle_consts_1.VehicleGroup.Team, keyFunc: function (vehicle) { return vehicle.team_id; } },
            { groupType: Vehicle_consts_1.VehicleGroup.IsTrailer, keyFunc: function (vehicle) { return !!vehicle.is_trailer; } }
        ];
        this.vehiclesStore = new data_store_1.default(groupFilters);
        this.vehiclesService = new vehicles_service_1.default(session);
        this.storableDataService = new storable_data_service_1.default(this.vehiclesStore);
        this.storableRealtimeSubscriptions = new storable_realtime_subscriptions_1.default(session, this.vehiclesStore, this.storableDataService);
    }
    VehiclesApi.prototype.load = function (id, options) {
        var _this = this;
        return this.storableDataService.load('load', function () { return _this.vehiclesService.load(id); }, id, options);
    };
    VehiclesApi.prototype.loadAll = function (options) {
        var _this = this;
        return this.storableDataService.loadAll('loadAll', function () { return _this.vehiclesService.loadAll(); }, options);
    };
    VehiclesApi.prototype.loadAllByTeam = function (teamId, options) {
        var _this = this;
        return this.storableDataService.loadAll('loadAllByTeam', function () { return _this.vehiclesService.loadAllByTeam(teamId); }, __assign(__assign({}, options), { groupType: Vehicle_consts_1.VehicleGroup.Team, groupValue: teamId }));
    };
    VehiclesApi.prototype.delete = function (id) {
        var _this = this;
        return this.storableDataService.delete('delete', function () { return _this.vehiclesService.delete(id); }, id);
    };
    VehiclesApi.prototype.update = function (id, vehicleData) {
        var _this = this;
        return this.storableDataService.modify('update', function () { return _this.vehiclesService.update(id, vehicleData); });
    };
    VehiclesApi.prototype.batchUpdate = function (vehicles) {
        return this.vehiclesService.batchUpdate(vehicles);
    };
    VehiclesApi.prototype.create = function (vehicleData) {
        var _this = this;
        return this.storableDataService.modify('create', function () { return _this.vehiclesService.create(vehicleData); });
    };
    VehiclesApi.prototype.updateStoreOnEvents = function () {
        this.storableRealtimeSubscriptions.updateStoreOnEvents([
            { name: Vehicle_consts_1.REAL_TIME_EVENTS.VEHICLE_UPDATE, isDelete: false },
            { name: Vehicle_consts_1.REAL_TIME_EVENTS.VEHICLE_DELETE, isDelete: true }
        ]);
    };
    VehiclesApi.prototype.onUpdate = function (callback) {
        return this.storableRealtimeSubscriptions.onEvent(Vehicle_consts_1.REAL_TIME_EVENTS.VEHICLE_UPDATE, function (item) { return callback(item.current); });
    };
    VehiclesApi.prototype.onDelete = function (callback) {
        return this.storableRealtimeSubscriptions.onEvent(Vehicle_consts_1.REAL_TIME_EVENTS.VEHICLE_DELETE, function (item) { return callback(item.current); });
    };
    VehiclesApi.prototype.onUnassigned = function (callback) {
        return this.storableRealtimeSubscriptions.onAnyEvent(Vehicle_consts_1.REAL_TIME_EVENTS.VEHICLE_UNASSIGNED, function (vehicle) {
            return callback(vehicle);
        });
    };
    VehiclesApi.prototype.get = function (id) {
        return this.vehiclesStore.get(id);
    };
    VehiclesApi.prototype.getAll = function () {
        return this.vehiclesStore.getAll();
    };
    VehiclesApi.prototype.getGroup = function (group, groupValue) {
        return this.vehiclesStore.getGroup(group, groupValue);
    };
    VehiclesApi.prototype.deleteMany = function (ids) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.all(ids.map(function (id) { return _this.delete(id); }))];
            });
        });
    };
    VehiclesApi.prototype.importVehiclesCsv = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.vehiclesService.importVehiclesCsv(file)];
            });
        });
    };
    VehiclesApi.prototype.getCsvUploadFields = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.vehiclesService.getCsvUploadFields()];
            });
        });
    };
    VehiclesApi.prototype.getAssignmentHistory = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.vehiclesService.getAssignmentHistory(id)];
            });
        });
    };
    VehiclesApi.prototype.loadPagedVehicles = function (cursor, limit, filters, page_action) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.vehiclesService.loadPagedVehicles(cursor, filters, limit, page_action)];
                    case 1:
                        response = _a.sent();
                        if (response && response.vehicles) {
                            this.storableDataService.updateManyInStores(response.vehicles);
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return VehiclesApi;
}());
exports.default = VehiclesApi;
//# sourceMappingURL=vehicles-api.js.map